<template>
  <div class="CancelReservations CommonContentSingle-gray">
    <el-dialog title="申请解禁" :visible.sync="dialogTableVisible" width="520px" append-to-body @close="clearAddInformation()">
      <el-form ref="form" :model="form" label-width="80px">
        <table class="CancelReservations" style="width: 100%">
          <tr>
            <td class="td_left">{{ $t('original.languages185') }}：</td>
            <td class="td_right">{{ addInformation.RealName }}</td>
          </tr>
          <tr>
            <td class="td_left"> {{ $t('original.languages218') }} ：</td>
            <td class="td_right">
              <el-select style="width: 300px" filterable @change="selectVsitorName()" v-model="addInformation.UserID" :placeholder="$t('original.languages3')">

                <el-option v-for="item in VsitorNameList" :key="item.UserID" :label="item.RealName" :value="item.UserID" :disabled="item.Disabled == 'true' ? true : false">
                </el-option>


              </el-select>
            </td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">{{ $t('original.languages219') }} </td>
            <td class="td_right">
              <el-input-number v-model="addInformation.RelieveRecordNum" :min="1" :max="8" label="描述文字"></el-input-number>
            </td>
          </tr>
          <tr v-if="addInformationShow">
            <td class="td_left">{{ $t('original.languages239') }}</td>
            <td class="td_right">
              <el-input type="textarea" v-model="addInformation.Assessment" resize="none"></el-input>
            </td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">{{ $t('original.languages220') }}</td>
            <td class="td_right">
              <el-input type="textarea" v-model="addInformation.RelieveRecordCause" resize="none"></el-input>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <div class="buttons" style="width: 100%">
                <el-button @click="dialogTableVisible = false">{{ $t('original.cancel') }}</el-button>
                <el-button type="primary" @click="AddApplyRelieve()" :loading="ApplyRelieveload">{{ $t('original.languages266') }}</el-button>
              </div>
            </td>
          </tr>
        </table>
      </el-form>
    </el-dialog>

    <el-dialog :title="$t('original.languages50')" :visible.sync="dialoginfoVisible" width="520px" append-to-body @close="clearAddInformation()">
      <el-form ref="form" label-width="80px">
        <table class="CancelReservations" style="width: 100%;background: rgba(255, 255, 255, 1);border-radius: 4px;">
          <tr>
            <td class="td_left">{{ $t('original.languages185') }}：</td>
            <td class="td_right">{{ AppointmentInfo.CounselorID }}</td>
          </tr>
          <tr>
            <td class="td_left">{{ $t('original.languages218') }}：</td>
            <td class="td_right">
              {{AppointmentInfo.RealName + "(" + AppointmentInfo.UserID + ")"}}
            </td>
          </tr>

          <tr>
            <td class="td_left">{{ $t('original.languages219') }}：</td>
            <td class="td_right">{{ AppointmentInfo.RelieveRecordNum }}</td>
          </tr>
          <tr>
            <td class="td_left">{{ $t('original.languages239') }}：</td>
            <td class="td_right">{{ AppointmentInfo.Assessment }}</td>
          </tr>

          <tr>
            <td class="td_left">{{ $t('original.languages220') }}：</td>
            <td class="td_right">
              {{ AppointmentInfo.RelieveRecordCause }}
            </td>
          </tr>
        </table>

        <table class="CancelReservations" style="width: 100%">
          <tr>
            <td class="td_left">{{ $t('original.languages190') }}</td>
            <td class="td_right" :style="AppointmentInfo.RelieveRecordState == 1 ? 'color: rgba(29, 154, 255, 1);' : AppointmentInfo.RelieveRecordState == 2 ? 'color: rgba(21, 191, 109, 1);' : AppointmentInfo.RelieveRecordState == 4 ? 'color: rgba(141, 141, 141, 1);' : 'color: rgba(242, 75, 78, 1);'">
              {{AppointmentInfo.RelieveRecordState == 1 ? $t('original.languages252') : AppointmentInfo.RelieveRecordState == 2 ? $t('original.languages203') : AppointmentInfo.RelieveRecordState == 4 ? $t('original.languages205') : $t('original.languages204')}}
            </td>
          </tr>

          <tr v-if="AppointmentInfo.RelieveRecordState == 2">
            <td class="td_left">{{ $t('original.note') }} </td>
            <td class="td_right">
              {{ AppointmentInfo.RelieveRecordNotes }}
            </td>
          </tr>

          <tr v-if="AppointmentInfo.RelieveRecordState == 3">
            <td class="td_left">{{ $t('original.languages191') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.RelieveRecordNotes }}
            </td>
          </tr>

          <tr v-if="AppointmentInfo.RelieveRecordState != 1 && AppointmentInfo.RelieveRecordState != 4">
            <td class="td_left">{{ $t('original.languages192') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.ApproverID }}
            </td>
          </tr>
          <tr v-if="AppointmentInfo.RelieveRecordState != 1 && AppointmentInfo.RelieveRecordState != 4">
            <td class="td_left">{{ $t('original.languages193') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.ApproverTime }}
            </td>
          </tr>
          <tr v-if="AppointmentInfo.RelieveRecordState == 1">
            <td colspan="2">
              <div class="buttons" style="width: 100%; text-align: right">
                <el-button @click="dialoginfoVisible = false"> {{ $t('original.cancel') }}</el-button>
                <el-button style="margin-right: 20px" type="primary" @click="evocation(AppointmentInfo.RelieveRecordID)"> {{ $t('original.languages253') }} </el-button>
              </div>
            </td>
          </tr>
        </table>
      </el-form>
    </el-dialog>

    <el-container>
      <el-header style="background: rgba(255, 255, 255, 1);min-height: 80px;height: auto;">
        <el-form ref="form" :model="form" label-width="80px"
          style="margin: 20px 0px;background: rgba(255, 255, 255, 1);overflow: hidden;height: 42px;padding: 10px;">
          <el-row style="float: left; height: 42px;">
            <el-col :xl="6" :lg="6" :md="6" :sm="6" :xs="24"><div class="grid-content">
                <el-form-item :label="$t('original.account')">
                  <el-input  v-model="form.UserID" style="width: 100%" :placeholder="$t('original.languages254')"></el-input>
                </el-form-item>
              </div>
            </el-col>
                <el-col :xl="6" :lg="6" :md="6" :sm="6" :xs="24"><div class="grid-content">
                <el-form-item :label="$t('original.Name_of_Company')" prop="bumen">
                  <div class="block">
                    <el-cascader ref="wcascader" emitPath:false :show-all-levels="false" v-model="form.DepartID" :options="DepartDrop" :props="{ checkStrictly: true, emitPath: false }" clearable></el-cascader>
                  </div>
                </el-form-item></div></el-col>

              <el-col :xl="6" :lg="6" :md="6" :sm="6" :xs="24"><div class="grid-content">
                <el-form-item :label="$t('original.languages190')">
                  <el-select v-model="form.CancelApproval" :placeholder="$t('original.languages3')">
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="待审批" value="1"></el-option>
                    <el-option label="已同意" value="2"></el-option>
                    <el-option label="已拒绝" value="3"></el-option>
                  </el-select>
                </el-form-item></div></el-col>
          </el-row>
          
          <el-row style="float: right; height: 42px;">
            <el-col :xl="24" style="text-align: right">
              <el-button type="primary" @click="aaa1()">{{ $t('original.screening') }}</el-button>
              <el-button type="primary" @click="clearFrom();">{{ $t('original.reset') }}</el-button>
            </el-col>
          </el-row>

        </el-form>
      </el-header>
      <el-main style="margin-top: 15px; background: rgba(255, 255, 255, 1)">
        <el-row>
          <el-col :xl="24" style="margin-bottom: 10px">
            <el-button type="primary" :loading="loadingstart" @click="getVsitorNameList()">{{ $t('original.languages274') }}</el-button>
          </el-col>
          <el-table ref="multipleTable" v-loading="load" :element-loading-text="$t('original.languages22')" element-loading-spinner="el-icon-loading" :data="tableData" tooltip-effect="dark" style="width: 100%">
            <el-table-column :label="$t('original.The_serial_number')" min-width="5%">
              <template slot-scope="scope">
                {{ (form.pageIndex - 1) * 10 + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="UserID" :label="$t('original.account')" min-width="10%"></el-table-column>
            <el-table-column prop="RealName" :label="$t('original.name')" min-width="10%"></el-table-column>
            <el-table-column prop="CounselorID" label="咨询师姓名" min-width="10%"></el-table-column>
            <el-table-column prop="Sex" :label="$t('original.gender')" min-width="6%"></el-table-column>
            <el-table-column prop="Age" :label="$t('original.languages256')" min-width="6%"></el-table-column>
            <el-table-column prop="DeptName" :label="$t('original.Name_of_Company')" min-width="20%"></el-table-column>
            <el-table-column prop="RelieveRecordNum" :label="$t('original.languages219')" min-width="8%"></el-table-column>
            <el-table-column prop="Used" :label="$t('original.languages275')" min-width="8%"></el-table-column>
            <el-table-column prop="CreatorTime" :label="$t('original.languages217')" min-width="15%"></el-table-column>
            <el-table-column prop="RelieveRecordState" :label="$t('original.languages190')" min-width="10%">
              <template slot-scope="scope">
                <span :class="scope.row.RelieveRecordState == 1 ? 'Statusblue' : scope.row.RelieveRecordState == 2 ? 'Statusgreen' : scope.row.RelieveRecordState == 4 ? 'Statusgray' : 'Statusred'">

                  {{ scope.row.RelieveRecordState == 1 ? $t('original.languages227') : scope.row.RelieveRecordState == 2 ? $t('original.languages203') : scope.row.RelieveRecordState == 4 ? $t('original.languages205') : $t('original.languages204')}}
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('original.languages49')" min-width="15%" align="center">
              <template slot-scope="scope">
                <span @click="dialoginfoVisible = true;SetAppointmentInfo(scope.row);" style="padding: 5px 10px; color: rgba(36, 153, 255, 1)">
                   {{ $t('original.languages174') }}
                </span>
                <span v-if="scope.row.RelieveRecordState == 1" style="padding: 5px 10px; color: rgba(36, 153, 255, 1)" @click="evocation(scope.row.RelieveRecordID)">
                   {{ $t('original.languages253') }}
                </span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange3" :current-page.sync="form.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Count"></el-pagination>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import add from "../Measurement/add.vue";
export default {
  components: { add },
  mounted() {
    this.getApplyRelieve();
    if (sessionStorage.getItem("department")) {
      this.DepartDrop = JSON.parse(sessionStorage.getItem("department"));
    } else {
      this.$Http_Post("DepartMent/GetDeparMent", {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          sessionStorage.setItem("department", JSON.stringify(res.Data));
          this.DepartDrop = res.Data;
        }
      });
    }
  },
  data() {
    return {
      Count:0,
      load: false,
      dialogTableVisible: false, // 添加取消预约弹框
      addInformationShow: false, //控制添加申请附加信息显示
      dialoginfoVisible: false,
      loadingstart: false,
      VsitorNameList: [],
      tableData: [], //列表表格数据
      DepartDrop: [],
      form: {
        entity: sessionStorage.getItem("entity"),
        CancelApproval: "",
        UserID: "",
        DepartID: "",
        pageSize: "10",
        pageIndex: "1",
      },

      addInformation: {
        RealName: JSON.parse(localStorage.getItem("userInfo")).UserName,
        UserID: "", //来访者姓名
        RelieveRecordNum: "",
        Assessment: "",
        RelieveRecordCause: "",
        RelieveRecordState: "",
        TermYM: "",
        // RealName: localStorage.getItem(JSON.parse(userInfo).UserName),
      },

      AppointmentInfo: {
        CounselorID: "",
        RealName: "",
        UserID: "",
        RelieveRecordNum: "",
        Assessment: "",
        RelieveRecordCause: "",
        RelieveRecordState: "",
        RelieveRecordNotes: "",
        ApproverID: "",
        ApproverTime: "",
      },
      ApplyRelieveload:false,
    };
  },
  methods: {
    aaa1() {
      this.form.pageIndex = "1"
      this.getApplyRelieve()
    },
    handleCurrentChange3(val) {
      this.form.pageIndex = val;
      // this.GetVolunteerList();
      this.getApplyRelieve()
    },
    getVsitorNameList() {
      this.loadingstart = true;
      this.$Http_Post("ConsultSubscribe/GetRelieveNameList", {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.loadingstart = false;
          this.VsitorNameList = res.Data;
          if (res.Data.length == 0) {
            this.$message(this.$t('original.languages273'));
          } else {
            this.dialogTableVisible = true;
          }
        }
      });
    },
    selectVsitorName() {
      for (let index = 0; index < this.VsitorNameList.length; index++) {
        if (this.VsitorNameList[index].UserID == this.addInformation.UserID) {
          this.addInformationShow = true;
          this.addInformation.TermYM = this.VsitorNameList[index].TermYM;
        }
      }
    },
    clearAddInformation() {
      this.addInformationShow = false;
      this.addInformation.AppointmentTime = "";
      this.addInformation.ConAddressName = "";
      this.addInformation.ConsultType = "";
      this.addInformation.CancelCause = "";
      this.addInformation.ConsultCntIntroduce = "";
      this.addInformation.ConsultTheme = "";
      this.addInformation.UserID = "";
    },
    AddApplyRelieve() {
      this.ApplyRelieveload=true;
      //申请解禁
      this.$Http_Post("ConsultSubscribe/AddApplyRelieve", {
        UserID: this.addInformation.UserID, //来访者姓名
        RelieveRecordNum: this.addInformation.RelieveRecordNum,
        Assessment: this.addInformation.Assessment,
        RelieveRecordCause: this.addInformation.RelieveRecordCause,
        TermYM: this.addInformation.TermYM,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message({
            message: this.$t('original.languages258'),
            type: "success",
          });
          this.dialogTableVisible = false;
          this.getApplyRelieve();
        }
        this.ApplyRelieveload=false;
      });
    },

    getApplyRelieve() {
      this.load = true;
      this.$Http_Post("ConsultSubscribe/GetApplyRelieve", this.form).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.tableData = res.Data.Lists;
            this.Count = res.Counts
            this.load = false;
          }
        }
      );
    },
    clearFrom() {
      this.form.CancelApproval = "";
      this.form.UserID = "";
      this.form.DepartID = "";
      this.form.pageIndex = "1"
      this.getApplyRelieve()
    },

    SetAppointmentInfo(row) {
      this.AppointmentInfo.CounselorID = row.CounselorID;
      this.AppointmentInfo.RealName = row.RealName;
      this.AppointmentInfo.UserID = row.UserID;
      this.AppointmentInfo.RelieveRecordNum = row.RelieveRecordNum;
      this.AppointmentInfo.Assessment = row.Assessment;
      this.AppointmentInfo.RelieveRecordCause = row.RelieveRecordCause;
      this.AppointmentInfo.RelieveRecordState = row.RelieveRecordState;
      this.AppointmentInfo.RelieveRecordNotes = row.RelieveRecordNotes;
      this.AppointmentInfo.ApproverID = row.ApproverID;
      this.AppointmentInfo.RelieveRecordID = row.RelieveRecordID;
      this.AppointmentInfo.ApproverTime = row.ApproverTime;
    },
    evocation(RelieveRecordID) {
      this.$Http_Post("ConsultSubscribe/UpdateApplyRelieve", {RelieveRecordID: RelieveRecordID,RelieveRecordState: 4,}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message({
            message: this.$t('original.languages259'),
            type: "success",
          });
          this.dialogTableVisible = false;
          for (let index = 0; index < this.tableData.length; index++) {
            if (RelieveRecordID == this.tableData[index].RelieveRecordID) {
              this.tableData[index].RelieveRecordState = 4;
            }
          }
        }
      });
    },
  },
};
</script>

<style>
.CancelReservations .td_left {
  color: rgba(141, 141, 141, 1);
  font-size: 14px;
  padding: 5px 15px;
  width: 40%;
}

.CancelReservations .td_right {
  text-align: left;
  font-size: 14px;
  color: rgba(40, 40, 40, 1);
}

.el-dialog {
  height: auto !important;
}

.CancelReservations .buttons {
  width: 100%;
  text-align: center;
  margin: 20px;
}

.CancelReservations .Statusblue {
  border-radius: 4px;
  padding: 5px 10px;
  background: rgba(29, 154, 255, 0.1);
  color: rgba(29, 154, 255, 1);
}
.CancelReservations .Statusgreen {
  border-radius: 4px;
  background-color: rgba(21, 191, 109, 0.1);
  color: rgba(21, 191, 109, 1);
  padding: 5px 10px;
}
.CancelReservations .Statusred {
  border-radius: 4px;
  background-color: rgba(242, 75, 78, 0.1);
  color: rgba(242, 75, 78, 1);
  padding: 5px 10px;
}
.CancelReservations .Statusgray {
  border-radius: 4px;
  padding: 5px 10px;
  background: rgba(141, 141, 141, 0.1);
  color: rgba(141, 141, 141, 1);
}
.el-table--enable-row-transition .el-table__body td{text-align: center;}
</style>
